module.exports = __webpack_public_path__ + "img/sv7on.ffbfa8a8.svg";